import { z } from "zod";

import { ErrorMessages } from "@/app/_module/constants";
import { isValidUSPhoneNumber } from "@/app/_module/utils/formatters";

export const profileInformationSchema = z.object({
 
  name: z
    .string()
    .min(1, { message: ErrorMessages.required("name") })
    .max(100, { message: "Name cannot exceed 100 characters" }),

  company: z
    .string()
    .max(100, { message: "Company name cannot exceed 100 characters" })
    .optional()
    .or(z.literal("")), 

  title: z
    .string()
    .max(100, { message: "Title cannot exceed 100 characters" })
    .optional()
    .or(z.literal("")),

  email: z
    .string({
      message: ErrorMessages.required("email"),
    })
    .min(1, { message: ErrorMessages.required("email") })
    .email({ message: ErrorMessages.invalidEmail })
    .max(255, { message: "Email cannot exceed 255 characters" }),

  // Personal contact phone number
  phone: z
    .string()
    .min(1, { message: ErrorMessages.required("phone") })
    .refine((val) => {
      // Accept both formatted (XXX) XXX-XXXX and raw 10-digit numbers
      const cleaned = val.replace(/\D/g, '');
      return cleaned.length === 10;
    }, "Phone number must be exactly 10 digits")
    .refine((val) => {
      const cleaned = val.replace(/\D/g, '');
      return isValidUSPhoneNumber(cleaned);
    }, "Please enter a valid US phone number"),

  // Default Twilio phone number for outbound calls and SMS (selected from agent's assigned numbers)
  defaultOutboundPhone: z
    .string()
    .optional(),

  // Call forwarding toggle
  callForwardingEnabled: z
    .boolean()
    .optional(),

  // SMS forwarding toggle
  smsForwardingEnabled: z
    .boolean()
    .optional(),
});
